import React, { useEffect } from 'react';
import { useERUMAUI } from '../ERUMAUI/Context_ERUMAUI';
import "./Stylesheet_Entry.css";
import DR_Logo from "../../Assets/Images/DR_Logo.png"
import UI_Form from '../ERUMAUI/UI_Form';
import UI_Input_Text from '../ERUMAUI/UI_Input_Text';
import UI_Image from '../ERUMAUI/UI_Image';
import UI_Button from '../ERUMAUI/UI_Button';
import UI_Divider from '../ERUMAUI/UI_Divider';
import UI_LinearGroup from '../ERUMAUI/UI_LinearGroup';


export default function Panel_Login() {
    const { LoadingScreen_Active_Set } = useERUMAUI();

    return (
        <div className='Login'>
            <UI_Image
                src={DR_Logo}
                Fit={true}
                className="Login_Logo"
                style={{width: "400px"}}
            />
            <div>
                <h1 className='General_Title'>
                    Welcome back!
                </h1>
                <UI_Form>
                    <UI_Input_Text
                        Label_Text="Email"
                        Input_Type="email"
                    />
                    <UI_Input_Text
                        Label_Text="Password"
                        Input_Type="password"
                    />
                </UI_Form>
            </div>
            
            <div className='Login_Action'>
                <UI_Button
                    Text="Login"
                    Fill={true}
                />
                <UI_Divider />
                <UI_LinearGroup
                    Fill={true}
                >
                    <UI_Button
                        Text="Create an account"
                    />
                    <UI_Button
                        Text="Forgot password"
                    />
                </UI_LinearGroup>
                
            </div>
            <span></span>
        </div>
    );
}